import * as Yup from 'yup'

export const notaSchema = Yup.object().shape({
  observacao: Yup.string()
    .trim()
    .max(512, 'Máximo de 512 caracteres')
    .when('action', {
      is: 'cancelar',
      then: (schema) => schema.required('Motivo é obrigatório'),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  valor: Yup.number()
    .nullable()
    .when('action', {
      is: (action: string) => action !== 'cancelar',
      then: (schema) =>
        schema.min(0.1, 'O valor mínimo é de R$ 0.1').required('Valor é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),
})
